import us from '../../defines';
import { env } from '../../lib/utility/browser-compatibility';
import app from '../../public-api';
import AnnotationsService from './annotations-service';
import { UiLoader } from './annotations-ui/UiLoader';
import './annotdraw'; // TODO: figure out a more elegant way to draw regions...
import ColorPicker from './color-picker/color-picker';
import { createKeyboardHandler } from './keyboard-handler';
import { NavigationService } from './navigation-service';
import { RegionInteraction } from './regions/region-interaction';
import {LegacyAnnotationProvider} from './LegacyAnnotationProvider';
import { TextEditPanel } from './text-edit-panel';

app.plugins.register({
  name: 'us:annotations:text-edit-panel',

  extends: 'uScope',

  constructor: TextEditPanel
});

app.plugins.register({
  name: 'us:annotations:color-picker',

  extends: 'uScope',

  canStart () {
    return !env.isIOS;
  },

  constructor: ColorPicker
});

app.plugins.register({
  name: 'us:annotations:ui',

  extends: 'uScope',

  canStart () {
    return !env.isIOS;
  },

  constructor: UiLoader
});

app.plugins.register({
  name: 'us:annotations:service',

  extends: 'viewport',

  dependencies: [
    'us:annotations:service-locator',
    'pi:platform-api',
    'us:annotations:text-edit-panel',
    'us:user-config'
  ],

  canStart () {
    return !env.isIOS;
  },

  factory (uScope, viewport, serviceLocator, {dataServer}, textEditPanel, userConfig) {
    const legacyAnnotationProvider = new LegacyAnnotationProvider(dataServer.client);
    const annotationsService = new AnnotationsService(uScope, viewport, legacyAnnotationProvider, textEditPanel, userConfig);

    createKeyboardHandler(uScope, viewport, annotationsService);

    viewport.events.on('viewport:image-close', () => {
      if (!us.ENABLEANNOTSELSAVE) { // if not saving selected annot each time the user selects one,
        annotationsService.regSelectSaveAtClose(); // then the last selected has yet to be saved, do so
      }
    });

    // HACK ALERT. The annotations service, ui and a few others have circular dependencies. This is a workaround. TODO: Untangle.
    viewport.events.on('viewport:selected', () => {
      serviceLocator.activeViewport = viewport;
      serviceLocator.annotationsService = annotationsService;
    });

    uScope.events.on(us.evREGIONSELECT, (parms) => {
      if (!serviceLocator.annotationsService) {
        return;
      }
      serviceLocator.annotationsService.regSelect(parms);
    });

    viewport.annots = annotationsService;
    return annotationsService;
  }
});

app.plugins.register({
  name: 'us:annotations:navigation-service',

  dependencies: ['us:annotations:service'],

  extends: 'viewport',

  constructor: NavigationService
});

// TODO: Integrate this directly into region class
app.plugins.register({
  name: 'us:annotations:region-interaction-hack',

  dependency: 'us:annotations:service-locator',

  extends: 'uScope',

  constructor: RegionInteraction
});

// HACK ALERT. The annotations service and ui have a circular dependency. This is a workaround. TODO: Untangle.
app.plugins.register({
  name: 'us:annotations:service-locator',

  extends: 'uScope',

  factory: () => ({})
});



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/annotations-loader.js